import { GlobalSearchResultTypeUnionType } from '@api';

type NavigationPathType = {
  to: string;
  params?: { id: string };
};

export const getNavigationPath = (
  type: GlobalSearchResultTypeUnionType,
  id: string
): NavigationPathType => {
  switch (type) {
    case 'COMPANY':
      return { to: '/companies/$id', params: { id } };
    case 'PERSON':
      return { to: '/persons/$id', params: { id } };
    case 'VENUE':
      return { to: '/venues/$id', params: { id } };
    case 'ARTIST':
      return { to: '/artists/$id', params: { id } };
    case 'TOUR':
      return { to: '/projects/touring/$id', params: { id } };
    default:
      return { to: '/' };
  }
};
